import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';
import {EChartsOption} from 'echarts';
import {
  DEFAULT_GAUGE_PALETTE,
  DetailsChartGaugeColor,
  DetailsChartsDto,
  IconType,
  IoniconsOutline,
  ND
} from '@pt/pt-models';

@Component({
  selector: 'pt-details-chart',
  templateUrl: './details-chart.component.html',
  styleUrls: ['./details-chart.component.scss']
})
export class DetailsChartComponent implements OnChanges, OnDestroy {
  @Input() title: string;
  @Input() titleHelp?: string;
  @Input() charts: DetailsChartsDto[];
  @Input() itemWidth?: string = 'auto'; //'230px';
  @Input() showReloadButton: boolean;
  @Input() gaugeColor: DetailsChartGaugeColor[] = DEFAULT_GAUGE_PALETTE;
  @Input() decimal = 0;

  @Output() reload = new EventEmitter<boolean>();
  public IconWarning = IoniconsOutline.warning;

  iconKey = IoniconsOutline.infoCircle;
  iconType = IconType.IONIC_ICON;
  defaultColor = '#333333';
  ND = ND;
  currentCharts: DetailsChartsDto[];
  availableStats = false;
  iconReload = IoniconsOutline.reload;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.charts) {
      this.updateCharts();
    }
  }

  generateChartPieOption(value: number, maxValue: number): EChartsOption {
    let currentValue = 0;
    if (value !== null && value !== undefined) {
      currentValue = value;
    }
    let currentMaxValue = currentValue;
    if (maxValue !== null && maxValue !== undefined) {
      currentMaxValue = maxValue;
    }
    currentValue = Math.round(currentValue)
    return {
      series: [
        {
          top: '0px',
          left: '0px',
          avoidLabelOverlap: false,
          type: 'pie',
          radius: ['65%', '55%'],
          center: ['50%', '50%'],
          animation: true,
          emphasis: {
            label: {
              show: false
            }
          },
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          tooltip: {
            show: false
          },
          data: [
            {value: currentMaxValue, itemStyle: {color: this.getColor(currentValue)}},
          ]
        }
      ]
    } as EChartsOption;
  }

  ngOnDestroy(): void {
    this.availableStats = false;
  }

  public getColor(currentValue: number) {
    const color = this.gaugeColor.sort((a, b) => a.maxValue > b.maxValue ? 1 : -1);
    for (const c of color) {
      if (currentValue <= c.maxValue) {
        return c.color;
      }
    }
    return this.defaultColor;
  }

  private updateCharts() {
    this.currentCharts = [];
    this.availableStats = true;
    this.charts?.forEach((chart: DetailsChartsDto) => {
      const options = this.generateChartPieOption(chart.value, chart.max);
      // if (!this.availableStats) {
      //   this.availableStats = chart.value !== null;
      // }
      this.currentCharts.push({
        label: chart.label,
        textValue: chart.textValue,
        value: chart.value,
        max: chart.max,
        options
      });
    });
  }
}
